(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["script-collection-product-grid"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  // ── Filter sidebar toggle (mobile: slide-in panel; desktop: always visible) ──
  function initFilterToggle() {
    const toggleBtns = document.querySelectorAll('[data-filter-toggle]');
    const overlay    = document.querySelector('[data-filter-overlay]');
    const filters    = document.getElementById('CollectionFilters');
    const closeBtn   = document.querySelector('[data-filter-close]');

    if (!toggleBtns.length || !filters) return;

    const isMobile = () => window.innerWidth <= 1024;

    function openFilters() {
      filters.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggleBtns.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    }

    function closeFilters() {
      filters.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggleBtns.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }

    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (isMobile()) {
          const isOpen = filters.classList.contains('is-open');
          isOpen ? closeFilters() : openFilters();
        }
      });
    });

    if (closeBtn)  closeBtn.addEventListener('click', closeFilters);
    if (overlay)   overlay.addEventListener('click', closeFilters);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && filters.classList.contains('is-open')) {
        closeFilters();
      }
    });
  }

  // ── Filter accordion groups ───────────────────────────────────
  function initFilterAccordions() {
    const toggles = document.querySelectorAll('[data-filter-group-toggle]');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const bodyId = toggle.getAttribute('aria-controls');
        const body   = document.getElementById(bodyId);
        if (!body) return;

        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        body.classList.toggle('is-open', !isOpen);
      });
    });
  }

  // ── Custom sort dropdown ─────────────────────────────────────
  function initSortDropdown() {
    const sortWrap     = document.querySelector('[data-sort-dropdown]');
    if (!sortWrap) return;

    const trigger      = sortWrap.querySelector('[data-sort-trigger]');
    const panel        = sortWrap.querySelector('.collection-grid_sort-panel');
    const options      = sortWrap.querySelectorAll('.collection-grid_sort-option');
    const nativeSelect = sortWrap.querySelector('.collection-grid_sort-native');

    if (!trigger || !panel) return;

    let isOpen = false;
    let animation = null;

    function openPanel() {
      isOpen = true;
      trigger.setAttribute('aria-expanded', 'true');

      // Measure full height
      panel.style.display = 'block';
      panel.style.overflow = 'hidden';
      const fullHeight = panel.scrollHeight;
      panel.style.height = '0';
      panel.style.opacity = '0';

      if (animation) animation.cancel();
      animation = panel.animate(
        [
          { height: '0px',             opacity: 0, transform: 'translateY(-4px)' },
          { height: fullHeight + 'px', opacity: 1, transform: 'translateY(0)'   }
        ],
        { duration: 220, easing: 'ease', fill: 'forwards' }
      );
      animation.onfinish = () => {
        panel.style.height   = 'auto';
        panel.style.overflow = '';
      };
    }

    function closePanel() {
      isOpen = false;
      trigger.setAttribute('aria-expanded', 'false');

      const currentHeight = panel.offsetHeight;
      panel.style.overflow = 'hidden';

      if (animation) animation.cancel();
      animation = panel.animate(
        [
          { height: currentHeight + 'px', opacity: 1, transform: 'translateY(0)'   },
          { height: '0px',                opacity: 0, transform: 'translateY(-4px)' }
        ],
        { duration: 180, easing: 'ease', fill: 'forwards' }
      );
      animation.onfinish = () => {
        panel.style.display  = 'none';
        panel.style.height   = '';
        panel.style.overflow = '';
      };
    }

    // Start hidden
    panel.style.display = 'none';

    trigger.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      isOpen ? closePanel() : openPanel();
    });

    options.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-sort-value');

        // Update aria-selected on all options
        options.forEach(o => o.setAttribute('aria-selected', 'false'));
        option.setAttribute('aria-selected', 'true');

        closePanel();

        // Navigate to sorted URL
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.assign(url.toString());
      });
    });

    document.addEventListener('click', e => {
      if (!sortWrap.contains(e.target)) closePanel();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closePanel();
    });
  }

  // ── Apply filters (drawer) ────────────────────────────────────
  // Handled by custom-scripts.js via AJAX (renderPage) — no form.submit to avoid page reload
  function initApplyFilters() {}

  // ── Sort select — Select2 (jQuery) ─────────────────────────────
  function initSelect2() {
    const el = document.getElementById('SortBy');
    if (!el || typeof window.jQuery === 'undefined') return;
    const $ = window.jQuery;
    if (!$.fn.select2) return;
    const $el = $(el);
    if ($el.hasClass('select2-hidden-accessible')) return;
    $el.select2({
      minimumResultsForSearch: -1,
      placeholder: 'Sort By',
      // width: '196px'
    });
  }

  // ── Init ──────────────────────────────────────────────────────
  function init() {
    initFilterToggle();
    initFilterAccordions();
    initSortDropdown();
    initApplyFilters();
    initSelect2();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-image-banner"] && !Shopify.designMode) return;
  try {
    /**
 * script-image-banner.liquid
 *
 * Animates the two product images into view when the banner
 * enters the viewport, using GSAP ScrollTrigger.
 *
 * GSAP owns: rotation, opacity, scale, y
 * CSS owns:  position, size only
 *
 * Start states (Figma default):
 *   Bottle:  rotation 25.787deg
 *   Tin:     rotation -17.318deg
 *
 * End states:
 *   Desktop (>768px):  bottle 14.75deg   | tin -7.38deg
 *   Mobile  (<=768px): bottle 25.787deg  | tin -17.318deg  (holds the Figma default angle)
 *
 * DEPENDENCIES — must be loaded in theme.liquid before </body>:
 *   <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js" defer></script>
 *   <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js" defer></script>
 */

(function () {
  'use strict';

  var BOTTLE_START = 25.787;
  var TIN_START    = -17.318;

  function initImageBanner(card) {
    var bottle = card.querySelector('[data-ib-bottle]');
    var tin    = card.querySelector('[data-ib-tin]');

    if (!bottle && !tin) return;

    gsap.registerPlugin(ScrollTrigger);

    // ── Set start states immediately to prevent flash ──
    if (bottle) {
      gsap.set(bottle, {
        opacity: 0,
        rotation: BOTTLE_START,
        scale: 0.75,
        y: 24,
        transformOrigin: 'center bottom',
      });
    }

    if (tin) {
      gsap.set(tin, {
        opacity: 0,
        rotation: TIN_START,
        scale: 0.75,
        y: 24,
        transformOrigin: 'center bottom',
      });
    }

    // ── Reveal timeline — end rotation differs per breakpoint ──
    // matchMedia rebuilds (and reverts) the timeline when crossing 768px.
    function build(bottleEnd, tinEnd) {
      var tl = gsap.timeline({
        defaults: { ease: 'power2.out' },
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          once: true,
        },
      });

      if (bottle) {
        tl.to(bottle, {
          opacity: 1,
          rotation: bottleEnd,
          scale: 1,
          y: 0,
          duration: 1.0,
        }, 0.15);
      }

      if (tin) {
        tl.to(tin, {
          opacity: 1,
          rotation: tinEnd,
          scale: 1,
          y: 0,
          duration: 1.0,
        }, 0.3);
      }
    }

    var mm = gsap.matchMedia();

    // Desktop / tablet — unchanged
    mm.add('(min-width: 769px)', function () {
      build(14.75, -7.38);
    });

    // Mobile — products settle at the Figma default angle
    mm.add('(max-width: 768px)', function () {
      build(BOTTLE_START, TIN_START);
    });
  }

  function init() {
    document.querySelectorAll('[data-image-banner]').forEach(initImageBanner);
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-interactive-banner"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initBanner(section) {
    const pattern   = section.querySelector('[data-banner-pattern]');
    const gradient  = section.querySelector('.homepage-banner_gradient');
    const bgText    = section.querySelector('[data-banner-bg-text]');
    const content   = section.querySelector('[data-banner-content]');
    const bottle    = section.querySelector('[data-banner-bottle]');
    const oliveLeft = section.querySelector('.homepage-banner_olive--top-left');
    const oliveMid  = section.querySelector('.homepage-banner_olive--mid-right');
    const oliveBot  = section.querySelector('.homepage-banner_olive--bottom-left');

    const isMobile = window.innerWidth <= 768;

    glueCopyToHeadline(section, content);

    gsap.registerPlugin(ScrollTrigger);

    gsap.set(bottle, {
      rotation: 7.167,
      xPercent: -50,
      yPercent: -50,
      x: 40,
      filter: 'blur(8.8px)',
      opacity: 0,
      transformOrigin: 'center center',
    });

    gsap.set(oliveLeft, {
      rotation: 0,
      y: -30,
      filter: 'blur(9.2px)',
      opacity: 0,
      transformOrigin: 'center center',
    });

    gsap.set(oliveMid, {
      rotation: 15.953,
      filter: 'blur(8.05px)',
      opacity: 0,
      transformOrigin: 'center center',
    });
    gsap.set(oliveBot, {
      rotation: isMobile ? 0 : 12.805,
      filter: 'blur(8.4px)',
      opacity: 0,
      transformOrigin: 'center center',
    });

    /*
     * Reveal timeline.
     */
    const tl = gsap.timeline({
      defaults: { ease: 'power2.out' },
      scrollTrigger: {
        trigger: section,
        start: 'top 50%',
        once: true,
        // markers: true,
      },
    });

    // 1. Background pattern — opacity 0 → 0.3
    tl.to(pattern, { opacity: 0.3, duration: 1.0 }, 0);

    // 2. Gradient overlay
    tl.to(gradient, { opacity: 1, duration: 0.8 }, 0.1);

    // 3. Background headline — slides in from the left
    tl.fromTo(
      bgText,
      { opacity: 0, x: -80 },
      { opacity: 1, x: 0, duration: 0.9 },
      0.15
    );

    // 4. Bottle — rotates from -3.873deg offset → -11.04deg, unblurs, slides from right
    tl.to(
      bottle,
      {
        rotation: 0,
        x: 0,
        filter: 'blur(0px)',
        opacity: 1,
        duration: 1.0,
      },
      0.25
    );

    // 5. Top-left branch — drops down (y: -30 → 0), fades in.
    //    Blur softens 9.2px → 2px but never fully clears (per design).
    //    No rotation animation.
    tl.to(
      oliveLeft,
      {
        y: 0,
        filter: 'blur(2px)',
        opacity: 1,
        duration: 0.9,
      },
      0.35
    );

    // 6. Mid-right olive — rotates +15.953deg offset → 0, unblurs
    tl.to(
      oliveMid,
      {
        rotation: 0,
        filter: 'blur(0px)',
        opacity: 1,
        duration: 0.9,
      },
      0.47
    );

    // 7. Bottom-left pair — rotates +12.805deg offset → 0, unblurs
    //    On mobile: no rotation, CSS holds the 35deg static value
    tl.to(
      oliveBot,
      {
        ...(isMobile ? {} : { rotation: 0 }),
        filter: 'blur(0px)',
        opacity: 1,
        duration: 0.9,
      },
      0.59
    );

    // 8. Body copy + CTA — last to appear
    tl.fromTo(
      content,
      { opacity: 0, y: 12 },
      { opacity: 1, y: 0, duration: 0.65 },
      0.5
    );
  }

  /*
   * Move the body copy inline, glued to the final word of the headline.
   * Both live inside a nowrap span, so the copy can never wrap onto a
   * line of its own — the last headline word travels down with it.
   */
  function glueCopyToHeadline(section, content) {
    const headline = section.querySelector('.homepage-banner_headline');
    if (!headline || !content) return;

    const h2 = headline.querySelector('h2:last-of-type');
    if (!h2 || h2.querySelector('.homepage-banner_glue')) return;

    // Last text node with actual content — skips trailing whitespace/markup.
    const walker = document.createTreeWalker(h2, NodeFilter.SHOW_TEXT);
    let lastText = null;
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.trim()) lastText = walker.currentNode;
    }
    if (!lastText) return;

    const glue = document.createElement('span');
    glue.className = 'homepage-banner_glue';

    // Leading text gets its own span too, so both halves of the line
    // are styleable / animatable independently.
    const lead = document.createElement('span');
    lead.className = 'homepage-banner_lead';

    const text = lastText.nodeValue.replace(/\s+$/, '');
    const cut  = text.lastIndexOf(' ');

    if (cut === -1) {
      // Single word in this node — the whole node is the last word.
      glue.appendChild(document.createTextNode(text));
    } else {
      lead.appendChild(document.createTextNode(text.slice(0, cut)));
      glue.appendChild(document.createTextNode(text.slice(cut)));
    }

    lastText.parentNode.insertBefore(lead, lastText);
    lastText.parentNode.insertBefore(glue, lastText);
    lastText.parentNode.removeChild(lastText);
    glue.appendChild(content);
  }

  function init() {
    document.querySelectorAll('[data-banner]').forEach(initBanner);
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-main-collection-banner-all"] && !Shopify.designMode) return;
  try {
    /**
 * Ranges slider — main-collection-banner.liquid (collection.handle == 'all')
 * Figma Desktop: 215-5453 | Mobile: 705-24034
 *
 * Desktop: 260px cards, 32px gutter, slides bleed past the container edge.
 * Mobile:  198px cards, 8px gap.
 * Arrows (48px circles, bottom-right) are shared by both breakpoints and lock
 * themselves when every card already fits.
 *
 * Swiper is loaded (deferred) in theme.liquid, so wait for it like the other
 * sliders in this theme do.
 */

(function () {
  'use strict';

  function initRangesSlider(wrap) {
    if (wrap.dataset.rangesInitialized === 'true') return;

    var swiperEl = wrap.querySelector('[data-ranges-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var prevBtn = wrap.querySelector('[data-ranges-prev]');
    var nextBtn = wrap.querySelector('[data-ranges-next]');

    wrap._rangesSwiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      grabCursor: true,
      loop: false,
      // Hide/lock the arrows when the cards all fit — and centre them, which
      // keeps the current look on collections with only 2–3 ranges.
      watchOverflow: true,
      centerInsufficientSlides: true,
      watchSlidesProgress: true,
      a11y: {
        prevSlideMessage: 'Previous ranges',
        nextSlideMessage: 'Next ranges',
      },
      breakpoints: {
        769: {
          spaceBetween: 32,
        },
      },
      navigation: (prevBtn && nextBtn) ? { prevEl: prevBtn, nextEl: nextBtn } : false,
    });

    wrap.dataset.rangesInitialized = 'true';
  }

  function init() {
    document.querySelectorAll('.collection-banner-all_grid-wrap').forEach(initRangesSlider);
  }

  function waitForSwiper(attempts) {
    attempts = attempts || 0;
    if (typeof Swiper !== 'undefined') {
      init();
    } else if (attempts < 50) {
      window.setTimeout(function () { waitForSwiper(attempts + 1); }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForSwiper(); });
  } else {
    waitForSwiper();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var wrap = e.target.querySelector('.collection-banner-all_grid-wrap');
    if (wrap) {
      wrap.dataset.rangesInitialized = 'false';
      waitForSwiper();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-main-podcast"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var HIDE_CLASS = 'hide';
  var DEBOUNCE_MS = 350;
  var RESULTS_CONTAINER_ID = 'PodcastResultsContainer';
  var SCROLL_ANCHOR_ID = 'AjaxScrollAnchor';

  // ── DOM refs ────────────────────────────────────────────
  var section          = document.querySelector('.main-podcast');
  var resultsContainer = document.getElementById(RESULTS_CONTAINER_ID);
  var lightbox         = document.querySelector('.podcast-lightbox');
  var lightboxEmbed    = document.getElementById('PodcastLightboxEmbed');
  var lightboxClose    = document.getElementById('PodcastLightboxClose');
  var lightboxBg       = document.getElementById('PodcastLightboxBackdrop');
  var searchInput      = document.querySelector('[data-podcast-search-input]');
  var searchForm       = document.querySelector('[data-podcast-search-form]');

  var currentQuery = '';
  var debounceTimer = null;
  var abortController = null;


  // ── Read more (episode card descriptions) ────────────────
  // Same behaviour as the product excerpt: collapse to MAX_LINES worth of copy
  // (measured from the rendered line-height so it holds across breakpoints) and
  // transition the height open. Re-run after every AJAX swap — the cards are
  // replaced wholesale by search/pagination.
  var READMORE_MAX_LINES = 5;

  function initReadMore(root) {
    var scope = root || document;
    var wraps = scope.querySelectorAll('[data-readmore]');

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.readmoreReady === 'true') return;
      wrap.dataset.readmoreReady = 'true';

      var textEl = wrap.querySelector('[data-readmore-text]');
      var btn    = wrap.querySelector('[data-readmore-btn]');
      var label  = btn && btn.querySelector('.podcast-card_read-more-text');
      if (!textEl || !btn) return;

      textEl.classList.add('is-js');

      var expanded  = false;
      var animating = false;

      function collapsedHeight() {
        var target = textEl.querySelector('p') || textEl;
        var cs = window.getComputedStyle(target);
        var lh = parseFloat(cs.lineHeight);
        if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.4;
        return Math.round(lh * READMORE_MAX_LINES);
      }

      // Measuring at height:auto flushes layout, so restore the previous height
      // and force a reflow — otherwise there's no start value to transition from.
      function fullHeight() {
        var prev = textEl.style.height;
        textEl.style.height = 'auto';
        var h = textEl.scrollHeight;
        textEl.style.height = prev;
        textEl.offsetHeight; // force reflow
        return h;
      }

      function setLabel() {
        if (label) label.textContent = expanded ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.classList.toggle('is-expanded', expanded);
        textEl.classList.toggle('is-expanded', expanded);
      }

      // Collapse to MAX_LINES, or drop the button entirely when the copy is short
      function applyCollapsed() {
        var collapsed = collapsedHeight();
        if (fullHeight() <= collapsed + 1) {
          textEl.style.height = '';
          btn.hidden = true;
          expanded = false;
          setLabel();
          return;
        }
        btn.hidden = false;
        textEl.style.height = collapsed + 'px';
        expanded = false;
        setLabel();
      }

      function onEnd(handler) {
        function done(e) {
          if (e && e.target !== textEl) return;
          textEl.removeEventListener('transitionend', done);
          animating = false;
          handler();
        }
        textEl.addEventListener('transitionend', done);
        // Safety net if the transition never fires (reduced motion, display:none…)
        window.setTimeout(function () {
          if (animating) done();
        }, 500);
      }

      applyCollapsed();

      btn.addEventListener('click', function () {
        if (animating) return;
        animating = true;

        if (expanded) {
          // Pin the current height so the transition has a start value
          textEl.style.height = textEl.scrollHeight + 'px';
          textEl.offsetHeight; // force reflow
          textEl.style.height = collapsedHeight() + 'px';
          expanded = false;
          setLabel();
          onEnd(function () {});
        } else {
          var target = fullHeight();
          textEl.style.height = collapsedHeight() + 'px';
          textEl.offsetHeight; // force reflow
          textEl.style.height = target + 'px';
          expanded = true;
          setLabel();
          onEnd(function () {
            // Let it reflow naturally once open (e.g. on resize)
            if (expanded) textEl.style.height = 'auto';
          });
        }
      });

      wrap._readmoreResize = function () {
        if (animating) return;
        if (expanded) textEl.style.height = 'auto';
        else applyCollapsed();
      };
    });
  }

  var readMoreResizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(readMoreResizeTimer);
    readMoreResizeTimer = window.setTimeout(function () {
      var wraps = document.querySelectorAll('[data-readmore]');
      Array.prototype.forEach.call(wraps, function (wrap) {
        if (typeof wrap._readmoreResize === 'function') wrap._readmoreResize();
      });
    }, 150);
  });

  // ── Helpers ──────────────────────────────────────────────
  function getPageUrl() {
    if (!section) return window.location.pathname;
    return section.getAttribute('data-page-url') || window.location.pathname;
  }

  function getYoutubeId(url) {
    if (!url) return null;
    var match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  }

  function buildPageUrl(q, page) {
    var path = getPageUrl();
    var params = new URLSearchParams();
    if (q) params.set('q', q);
    if (page && page > 1) params.set('page', String(page));
    var query = params.toString();
    return path + (query ? '?' + query : '');
  }

  function extractResultsHtml(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var inner = wrap.querySelector('#' + RESULTS_CONTAINER_ID);
    return inner ? inner.innerHTML : html;
  }

  function setLoading(loading) {
    if (resultsContainer) resultsContainer.classList.toggle('is-loading', !!loading);
  }

  function scrollToResultsTop() {
    var headerOffset = 80;
    var anchor = (section && section.querySelector('#' + SCROLL_ANCHOR_ID)) || document.getElementById(SCROLL_ANCHOR_ID) || resultsContainer;
    var top = anchor.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function loadResults(q, page, pushState) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    setLoading(true);

    fetch(buildPageUrl(q, page), { signal: abortController.signal })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (resultsContainer) {
          resultsContainer.innerHTML = extractResultsHtml(html);
          initReadMore(resultsContainer);
          if (searchInput) searchInput.value = q;
        }
        if (pushState) history.pushState({ q: q, page: page || 1 }, '', buildPageUrl(q, page));
        window.requestAnimationFrame(scrollToResultsTop);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          window.location.href = buildPageUrl(q, page);
        }
      })
      .finally(function () {
        setLoading(false);
      });
  }

  // ── Search init ─────────────────────────────────────────
  if (section && resultsContainer) {
    initReadMore(section);

    var params = new URLSearchParams(window.location.search);
    currentQuery = (params.get('q') || '').trim();
    if (searchInput) searchInput.value = currentQuery;

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          currentQuery = (searchInput.value || '').trim();
          loadResults(currentQuery, 1, true);
        }, DEBOUNCE_MS);
      });
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        currentQuery = (searchInput && searchInput.value) ? searchInput.value.trim() : '';
        loadResults(currentQuery, 1, true);
      });
    }

    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search);
      currentQuery = (p.get('q') || '').trim();
      var page = parseInt(p.get('page'), 10) || 1;
      if (searchInput) searchInput.value = currentQuery;
      loadResults(currentQuery, page, false);
    });

    // ── Pagination: AJAX fetch
    section.addEventListener('click', function (e) {
      var link = e.target.closest('a.pagination__item');
      if (!link) return;
      if (link.closest('#' + RESULTS_CONTAINER_ID) === null) return;
      if (link.hasAttribute('aria-disabled') || link.getAttribute('aria-current')) return;
      if (!link.href) return;

      e.preventDefault();

      var fetchUrl = new URL(link.href, window.location.origin).pathname + new URL(link.href, window.location.origin).search;
      setLoading(true);

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Network error ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newResults = doc.getElementById(RESULTS_CONTAINER_ID);
          if (newResults && resultsContainer) {
            resultsContainer.innerHTML = newResults.innerHTML;
            initReadMore(resultsContainer);
            if (searchInput) {
              var urlParams = new URLSearchParams(fetchUrl.split('?')[1] || '');
              searchInput.value = urlParams.get('q') || '';
            }
            history.pushState({}, '', fetchUrl);
            window.requestAnimationFrame(scrollToResultsTop);
          }
        })
        .catch(function (err) {
          console.error('[main-podcast] pagination fetch failed:', err);
          window.location.href = fetchUrl;
        })
        .finally(function () {
          setLoading(false);
        });
    });
  }

  // ── Lightbox ─────────────────────────────────────────────
  function openLightbox(youtubeUrl, title) {
    var videoId = getYoutubeId(youtubeUrl);
    if (!videoId || !lightbox || !lightboxEmbed) return;

    var embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
    lightboxEmbed.innerHTML = '<iframe src="' + embedUrl + '" title="' + (title || 'Episode video') + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    lightbox.classList.remove(HIDE_CLASS);
    document.body.style.overflow = 'hidden';

    // Focus close button for accessibility
    if (lightboxClose) lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.add(HIDE_CLASS);
    if (lightboxEmbed) lightboxEmbed.innerHTML = '';
    document.body.style.overflow = '';
  }

  if (lightboxClose) {
    lightboxClose.addEventListener('click', closeLightbox);
  }

  if (lightboxBg) {
    lightboxBg.addEventListener('click', closeLightbox);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  // Delegate play button clicks (featured + grid cards) — use document so it works even if section loads late
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-youtube-url]');
    if (btn && btn.closest('.main-podcast')) {
      e.preventDefault();
      openLightbox(btn.getAttribute('data-youtube-url'), btn.getAttribute('data-episode-title'));
    }
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-main-product"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var section = document.querySelector('.product_section[data-product-id]');
  if (!section) return;

  var pid = section.dataset.productId;
  var productHandle = section.dataset.productHandle;
  var currencySymbol = section.dataset.currencySymbol || '£';

  function initGallery() {
    var swiperEl = document.getElementById('ProductSwiper-' + pid);
    if (!swiperEl || swiperEl.querySelectorAll('.swiper-slide').length <= 1) return;

    function runSwiper() {
      if (typeof Swiper === 'undefined') return;
      if (swiperEl.swiper) return; /* already initialized */
      new Swiper('#ProductSwiper-' + pid, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        breakpoints: {
          769: { slidesPerView: 1.425 },
        },
        navigation: {
          nextEl: '.product_gallery-next-' + pid,
          prevEl: '.product_gallery-prev-' + pid,
          disabledClass: 'is-disabled',
        },
        pagination: {
          el: '#ProductPagination-' + pid,
          bulletClass: 'product_gallery-dot',
          bulletActiveClass: 'is-active',
          clickable: true,
          renderBullet: function (i, cls) {
            return '<span class="' + cls + '" aria-label="Go to image ' + (i + 1) + '"></span>';
          },
        },
      });
    }

    function waitForSwiper(callback, attempts) {
      attempts = attempts || 0;
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < 30) {
        setTimeout(function () { waitForSwiper(callback, attempts + 1); }, 50);
      }
    }

    waitForSwiper(runSwiper);
  }

  function initLightbox() {
    var lb      = document.getElementById('ProductLightbox');
    var lbImg   = document.getElementById('LightboxImg');
    var lbClose = lb && lb.querySelector('.product_lightbox-close');
    var lbBack  = lb && lb.querySelector('.product_lightbox-backdrop');

    if (!lb || !lbImg) return;

    var zoomBtns = document.querySelectorAll('#MainProduct-' + pid + ' .product_zoom-btn');
    zoomBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        lbImg.src = btn.dataset.lightboxSrc;
        lbImg.alt = btn.dataset.lightboxAlt || '';
        lb.removeAttribute('hidden');
        // Allow CSS transition to run (hidden -> visible + fade)
        requestAnimationFrame(function () {
          lb.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
        if (lbClose) lbClose.focus();
      });
    });

    function closeLightbox() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';

      function finalizeClose() {
        lb.setAttribute('hidden', '');
        lbImg.src = '';
        lb.removeEventListener('transitionend', onEnd);
      }

      function onEnd(e) {
        if (e.target !== lb) return;
        if (e.propertyName !== 'opacity') return;
        finalizeClose();
      }

      // If transitions are disabled or don't fire, still finalize.
      lb.addEventListener('transitionend', onEnd);
      window.setTimeout(finalizeClose, 450);
    }

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lbBack) lbBack.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hasAttribute('hidden')) closeLightbox();
    });
  }

  function initVariants() {
    var pills     = document.querySelectorAll('#MainProduct-' + pid + ' .product_variant-pill');
    var hiddenId  = document.getElementById('VariantId-' + pid);
    var labelEl   = document.getElementById('VariantLabel-' + pid);
    var priceWrap = document.getElementById('ProductPrice-' + pid);
    var atcBtn    = document.getElementById('ATCBtn-' + pid);
    var qtyInput  = section.querySelector('.product_qty-input');

    /* Stock caps keyed by variant id. The cart does not reject over-quantity
       adds on this store, so the stepper enforces the limit. `max` is what may
       still be added on top of what the cart already holds; null = uncapped. */
    var stock = {};
    var stockEl = document.getElementById('VariantStock-' + pid);
    if (stockEl) {
      try { stock = JSON.parse(stockEl.textContent); } catch (e) { stock = {}; }
    }

    function applyStock(variantId) {
      var info = stock[String(variantId)];
      if (!info) return;

      if (qtyInput) {
        if (info.max === null) qtyInput.removeAttribute('max');
        else qtyInput.setAttribute('max', info.max);
        qtyInput.dataset.variantId = variantId;
        qtyInput.dataset.inCart = info.inCart;

        var val = parseInt(qtyInput.value, 10) || 1;
        if (info.max !== null) val = Math.min(val, Math.max(1, info.max));
        qtyInput.value = Math.max(1, val);
      }

      if (atcBtn) {
        var maxedOut = info.max !== null && info.max <= 0;
        var label = !info.available ? 'Sold out' : (maxedOut ? 'All stock in cart' : 'Add to cart');
        atcBtn.disabled = !info.available || maxedOut;
        var span = atcBtn.querySelector('span');
        if (span) span.textContent = label;
        else atcBtn.textContent = label;
      }

      if (typeof window.syncQtyState === 'function') window.syncQtyState(qtyInput);
    }

    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-unavailable')) return;

        pills.forEach(function (p) { p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false'); });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');

        var variantId = pill.dataset.variantId;
        if (hiddenId) hiddenId.value = variantId;
        if (labelEl)  labelEl.textContent = pill.dataset.variantValue;

        applyStock(variantId);

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          history.replaceState({}, '', url.toString());
        }

        fetch('/products/' + productHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var v = data.variants.find(function (v) { return String(v.id) === String(variantId); });
            if (!v) return;

            if (priceWrap) {
              var symbol    = currencySymbol;
              var formatted = symbol + (v.price / 100).toFixed(2);
              var cur = priceWrap.querySelector('.product_price-current');
              if (cur) cur.textContent = formatted;
              var was = priceWrap.querySelector('.product_price-was');
              if (v.compare_at_price && v.compare_at_price > v.price) {
                if (!was) { was = document.createElement('span'); was.className = 'product_price-was text-grey'; priceWrap.appendChild(was); }
                was.innerHTML = '<s>' + symbol + (v.compare_at_price / 100).toFixed(2) + '</s>';
              } else if (was) { was.remove(); }
            }
          });
      });
    });
  }

  function initReadMore() {
    var btn     = document.getElementById('ReadMoreBtn-' + pid);
    var excerpt = document.getElementById('ProductExcerpt-' + pid);
    var textEl  = btn && btn.querySelector('.product_read-more-text');
    if (!btn || !excerpt) return;

    var MAX_LINES = 3;
    var expanded  = false;
    var animating = false;

    // Height of MAX_LINES of copy, measured from the rendered line-height so it
    // stays correct across breakpoints and font-size changes.
    function collapsedHeight() {
      var target = excerpt.querySelector('p') || excerpt;
      var cs = window.getComputedStyle(target);
      var lh = parseFloat(cs.lineHeight);
      if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.4;
      return Math.round(lh * MAX_LINES);
    }

    // Measuring at height:auto flushes layout, so restore the previous height
    // and force a reflow — otherwise the browser never sees a start value to
    // transition from and the expand snaps open.
    function fullHeight() {
      var prev = excerpt.style.height;
      excerpt.style.height = 'auto';
      var h = excerpt.scrollHeight;
      excerpt.style.height = prev;
      excerpt.offsetHeight; // force reflow
      return h;
    }

    function setLabel() {
      if (textEl) textEl.textContent = expanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.classList.toggle('is-expanded', expanded);
      excerpt.classList.toggle('is-expanded', expanded);
    }

    // Collapse to MAX_LINES, or drop the button entirely when the copy is short
    function applyCollapsed() {
      var collapsed = collapsedHeight();
      if (fullHeight() <= collapsed + 1) {
        excerpt.style.height = '';
        btn.hidden = true;
        expanded = false;
        setLabel();
        return;
      }
      btn.hidden = false;
      excerpt.style.height = collapsed + 'px';
      expanded = false;
      setLabel();
    }

    function onEnd(handler) {
      function done(e) {
        if (e && e.target !== excerpt) return;
        excerpt.removeEventListener('transitionend', done);
        animating = false;
        handler();
      }
      excerpt.addEventListener('transitionend', done);
      // Safety net if the transition never fires (reduced motion, display:none…)
      window.setTimeout(function () {
        if (animating) done();
      }, 500);
    }

    applyCollapsed();

    btn.addEventListener('click', function () {
      if (animating) return;
      animating = true;

      if (expanded) {
        // Pin the current height so the transition has a start value
        excerpt.style.height = excerpt.scrollHeight + 'px';
        // eslint-disable-next-line no-unused-expressions
        excerpt.offsetHeight; // force reflow
        excerpt.style.height = collapsedHeight() + 'px';
        expanded = false;
        setLabel();
        onEnd(function () {});
      } else {
        var target = fullHeight();
        // Pin the collapsed height as the transition's start value
        excerpt.style.height = collapsedHeight() + 'px';
        excerpt.offsetHeight; // force reflow
        excerpt.style.height = target + 'px';
        expanded = true;
        setLabel();
        onEnd(function () {
          // Let it reflow naturally once open (e.g. on resize)
          if (expanded) excerpt.style.height = 'auto';
        });
      }
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (animating) return;
        if (expanded) excerpt.style.height = 'auto';
        else applyCollapsed();
      }, 150);
    });
  }

  function initProductAccordions() {
    var container = document.querySelector('#MainProduct-' + pid + ' [data-product-accordions]');
    if (!container) return;
    var items = container.querySelectorAll('[data-accordion-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var answer = item.querySelector('[data-accordion-answer]');
      if (!trigger || !answer) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          closeProductAccordionItem(item, answer, trigger);
        } else {
          /* Close all others first */
          items.forEach(function (other) {
            if (other !== item) {
              var oAnswer = other.querySelector('[data-accordion-answer]');
              var oTrigger = other.querySelector('[data-accordion-trigger]');
              if (oAnswer && oTrigger && other.classList.contains('is-open')) {
                closeProductAccordionItem(other, oAnswer, oTrigger);
              }
            }
          });
          openProductAccordionItem(item, answer, trigger);
        }
      });
    });
  }

  function openProductAccordionItem(item, answer, trigger) {
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'max-height') return;
      if (item.classList.contains('is-open')) {
        answer.style.maxHeight = 'none';
      }
      answer.removeEventListener('transitionend', onEnd);
    });
  }

  function closeProductAccordionItem(item, answer, trigger) {
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    if (answer.style.maxHeight === 'none' || answer.style.maxHeight === '') {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
    answer.offsetHeight;
    answer.style.maxHeight = '0';
  }

  function initTasteProfileTooltips() {
    var wraps = section.querySelectorAll('.taste-profile_info-wrap');
    wraps.forEach(function (wrap) {
      var btn     = wrap.querySelector('.taste-profile_info-btn');
      var tooltip = wrap.querySelector('.taste-profile_tooltip');
      if (!btn || !tooltip) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        tooltip.hidden = isOpen;
      });

      document.addEventListener('click', function onOutside(e) {
        if (!wrap.contains(e.target)) {
          btn.setAttribute('aria-expanded', 'false');
          tooltip.hidden = true;
        }
      });

      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape') {
          btn.setAttribute('aria-expanded', 'false');
          tooltip.hidden = true;
        }
      });
    });
  }

  function init() {
    initGallery();
    initLightbox();
    initVariants();
    initReadMore();
    initProductAccordions();
    initTasteProfileTooltips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-recommended-products"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  var minToReplace = 5;

  function loadRecommendations(sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;
    var productId = sectionEl.dataset.productId;
    var limit     = sectionEl.dataset.limit || 5;
    var cartFallback = sectionEl.dataset.cartWithCollectionFallback === 'true';

    if (!productId) return;

    var url = routesRoot + 'recommendations/products'
      + '?section_id=' + encodeURIComponent(sectionId)
      + '&product_id=' + encodeURIComponent(productId)
      + '&limit='      + limit
      + '&intent=related';

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser   = new DOMParser();
        var doc      = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.rec-products_inner');

        if (!newInner) return;

        if (cartFallback) {
          var items = newInner.querySelectorAll('.rec-products_item');
          if (items.length < minToReplace) return;
        }

        var target = sectionEl.querySelector('.rec-products_inner');
        if (target) target.innerHTML = newInner.innerHTML;
      })
      .catch(function (err) {
        console.warn('[rec-products] Recommendations fetch failed:', err);
      });
  }

  document.querySelectorAll('.rec-products[data-section-id]').forEach(function (el) {
    // A server-rendered same-brand grid is already correct; don't overwrite it.
    // Test for the attribute, not its value: an empty value is still a brand grid.
    if (el.hasAttribute('data-brand-grid')) return;
    if (el.dataset.productId) loadRecommendations(el);
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initReviews(sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;
    var isMobile  = window.innerWidth <= 768;

    new Swiper('#ReviewsSwiper-' + sectionId, {
      slidesPerView  : isMobile ? 1.56 : 2.1,
      spaceBetween   : isMobile ? 32 : 32,
      loop           : false,
      navigation     : {
        prevEl        : '#Reviews-' + sectionId + ' .reviews_nav-prev',
        nextEl        : '#Reviews-' + sectionId + ' .reviews_nav-next',
        disabledClass : 'is-disabled',
      },
      pagination     : {
        el                : '#ReviewsPagination-' + sectionId,
        bulletClass       : 'slider-dot',
        bulletActiveClass : 'is-active',
        clickable         : true,
        renderBullet      : function (i, cls) {
          return '<span class="' + cls + '"></span>';
        },
      },
    });
  }

  function init() {
    document.querySelectorAll('.reviews[data-section-id]').forEach(function (el) {
      initReviews(el);
    });
  }

  if (typeof Swiper !== 'undefined') {
    init();
  } else {
    window.addEventListener('load', init);
  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-video"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function attemptAutoplay(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll('.video_section video[data-autoplay-video]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', 'muted');

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // Browser policy may block autoplay until user interaction.
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attemptAutoplay(document);
    }, { once: true });
  } else {
    attemptAutoplay(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    attemptAutoplay(event.target || document);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
